module.exports = __webpack_public_path__ + "img/login_mzl.b6855cfe.png";